var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_CONFIG } from './defaults';
export var LOCAL_CONFIG = __assign(__assign({}, DEFAULT_CONFIG), { NODE_ENV: 'local', URL: 'http://fraimsy.localhost/', 
    // API config
    API_URL: '/api/', STRIPE: {
        KEY: 'pk_test_51IIEvXFKPXYJMiWA5rNpqVzoBCp16jmsbGSEXAP8LPFyUy4ecpuBgxb7AJw5t5WD4ywFvSEzbgFyADITKl0X20eW00fwhIfn1o',
    } });
